// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HarborFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HarborFilledIcon" ref={forwardedRef} {...props}>
      <path d="M11.25 7.736a3.501 3.501 0 1 0-2.5.066V9H6.413v2.5H8.75v4.432A4.13 4.13 0 0 1 5.875 12H2.75v2.25h1.283a6.377 6.377 0 0 0 11.934 0h1.283V12h-3.125a4.13 4.13 0 0 1-2.875 3.932V11.5h2.163V9H11.25zM10.913 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const HarborFilledIcon = /* @__PURE__ */ Object.assign(
  HarborFilledIconComponent,
  { displayName: 'HarborFilledIcon' },
);
